export const hotelViewStyles = {
  container: {
    maxWidth: 1082,
    borderRadius: 2,
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  imageGallery: {
    display: 'flex',
    gap: 1,
    height: 600,
  },
  mainImage: {
    flex: '2',
    position: 'relative',
    height: '100%',
  },
  imageBox: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 1,
    cursor: 'pointer',
  },
  sideImagesContainer: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    height: '100%',
  },
  sideImageBox: {
    flex: '1',
    position: 'relative',
    minHeight: 0,
    maxHeight: 'calc(33.33% - 4px)',
  },
  imageOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 1,
    cursor: 'pointer',
  },
  hotelInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  ratingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mt: 1,
  },
  ratingInfo: {
    display: 'flex',
    gap: 1,
    alignItems: 'center',
  },
} as const;

export const modalStyles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: 'rgba(0, 0, 0, 0.9)',
  },
  modalContainer: {
    position: 'relative',
    width: '95vw',
    height: '95vh',
    bgcolor: 'transparent',
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalButton: {
    position: 'absolute',
    zIndex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },
  },
  closeButton: {
    top: 8,
    right: 8,
  },
  navButton: {
    top: '50%',
    transform: 'translateY(-50%)',
  },
  prevButton: {
    left: 8,
  },
  nextButton: {
    right: 8,
  },
  modalImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    borderRadius: 1,
  },
  imageCounter: {
    position: 'absolute',
    bottom: 20,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    color: 'white',
    px: 3,
    py: 1.5,
    borderRadius: 2,
  },
} as const;
